import React from 'react';
import { useLanguage } from '../i18nContext';
import StaticPageLayout from './StaticPageLayout';

interface Props { onBack: () => void; }

export default function PrivacyPage({ onBack }: Props) {
  const { language } = useLanguage();
  const en = language === 'en';

  return (
    <StaticPageLayout title={en ? 'Privacy Policy' : '隐私协议'} onBack={onBack}>
      <div className="bg-white rounded-2xl border border-surface-border p-8 md:p-12">
        <h2 className="text-3xl font-bold text-brand-900 font-serif mb-2">{en ? 'Privacy Policy' : '隐私协议'}</h2>
        <p className="text-sm text-ink-muted mb-8">{en ? 'Last updated: February 2026' : '最后更新：2026 年 2 月'}</p>

        <div className="space-y-8 text-ink-secondary leading-relaxed">
          <section>
            <h3 className="text-lg font-bold text-brand-900 mb-2">{en ? '1. Information We Collect' : '1. 我们收集的信息'}</h3>
            <p>{en ? 'We collect information you provide directly, such as account details, uploaded audio files, and meeting content. We also collect usage data to improve our services.' : '我们收集您直接提供的信息，如账户详情、上传的音频文件和会议内容。我们还收集使用数据以改进服务。'}</p>
          </section>
          <section>
            <h3 className="text-lg font-bold text-brand-900 mb-2">{en ? '2. How We Use Your Information' : '2. 我们如何使用您的信息'}</h3>
            <p>{en ? 'Your data is used to provide transcription and meeting intelligence services, improve accuracy, and communicate with you about your account.' : '您的数据用于提供转录和会议智能服务、提高准确性，以及就您的账户与您沟通。'}</p>
          </section>
          <section>
            <h3 className="text-lg font-bold text-brand-900 mb-2">{en ? '3. Data Storage & Security' : '3. 数据存储与安全'}</h3>
            <p>{en ? 'All data is encrypted in transit and at rest. Audio files are processed securely and can be deleted at your request.' : '所有数据在传输和存储时均经过加密。音频文件经过安全处理，可应您的要求删除。'}</p>
          </section>
          <section>
            <h3 className="text-lg font-bold text-brand-900 mb-2">{en ? '4. Data Sharing' : '4. 数据共享'}</h3>
            <p>{en ? 'We do not sell your personal data. We may share data with service providers who help us operate our platform, under strict confidentiality agreements.' : '我们不会出售您的个人数据。我们可能会在严格的保密协议下与帮助我们运营平台的服务提供商共享数据。'}</p>
          </section>
          <section>
            <h3 className="text-lg font-bold text-brand-900 mb-2">{en ? '5. Your Rights' : '5. 您的权利'}</h3>
            <p>{en ? 'You have the right to access, correct, or delete your personal data at any time. Contact us at privacy@minutesai.com for any requests.' : '您有权随时访问、更正或删除您的个人数据。如有任何请求，请联系 privacy@minutesai.com。'}</p>
          </section>
        </div>
      </div>
    </StaticPageLayout>
  );
}
